import {StyleSheet} from 'react-native';
import {FONTS} from '../../../utils/Constants';

// Theme-aware styles factory (the makeStyles pattern — docs/DARK-MODE.md):
// consumed via useThemedStyles(makeStyles) so colors re-resolve on theme
// change instead of baking at module load.
const makeStyles = colors =>
  StyleSheet.create({
    inputTitleStyle: {
      fontFamily: FONTS.semiboldFont,
      fontSize: 16,
      lineHeight: 24,
      color: colors.textMuted,
      marginBottom: 8,
      marginTop: 24,
    },
    dropdown: {
      height: 55,
      borderColor: colors.borderMuted,
      borderWidth: 1,
      borderRadius: 16,
      paddingHorizontal: 10,
    },
    icon: {
      marginRight: 5,
    },
    label: {
      position: 'absolute',
      backgroundColor: colors.background,
      left: 22,
      top: 8,
      zIndex: 999,
      paddingHorizontal: 8,
      fontSize: 14,
      fontFamily: FONTS.regularFont,
    },
    placeholderStyle: {
      fontSize: 16,
      fontFamily: FONTS.regularFont,

      color: colors.textMuted,
    },
    selectedTextStyle: {
      fontSize: 16,
      fontFamily: FONTS.regularFont,
      color: colors.textPrimary,
    },
    iconStyle: {
      width: 20,
      height: 20,
    },
    inputSearchStyle: {
      height: 40,
      fontSize: 16,
      fontFamily: FONTS.regularFont,
      color: colors.textPrimary,
    },
    // The dropdown list popup — the library defaults render white-on-white
    // in dark mode, so the container and item text carry theme colors.
    dropdownContainer: {
      backgroundColor: colors.surfaceElevated,
      borderColor: colors.border,
    },
    itemText: {
      color: colors.textPrimary,
    },
  });

export default makeStyles;
